import { render, staticRenderFns } from "./PageDetail.vue?vue&type=template&id=e7641fd6&scoped=true"
import script from "./PageDetail.vue?vue&type=script&lang=js"
export * from "./PageDetail.vue?vue&type=script&lang=js"
import style0 from "./PageDetail.vue?vue&type=style&index=0&id=e7641fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7641fd6",
  null
  
)

export default component.exports